import { z } from 'zod';
export const offerRequestAttachmentSchema = z.object({
    uuid: z.uuid(),
    url: z.string(),
    displayName: z.string(),
    mimeType: z.string(),
});
